import CommonCalendarHeader, {
  CalendarHeaderProps,
} from 'components/common/calendar/common/header/CommonCalendarHeader';
import 'components/common/calendar/style/react-datepicker.css';
import { TextType } from 'components/common/title/Title';
import { ko } from 'date-fns/locale';
import { RefObject } from 'react';
import DatePicker from 'react-datepicker';
import { setTomorrow } from 'utils/date/setTomorrow';

const calendarInputStyle = 'bg-transparent w-full h-full py-1 border-none text-gray-44 tracking-tighter';

type Props = {
  calendarRef: RefObject<DatePicker<never, undefined>>;
  handleRange: any;
  startDate: Date | null;
  endDate: Date | null;
};

const RangeCalendar = ({ calendarRef, handleRange, startDate, endDate }: Props) => {
  // custom header
  const renderHeader = ({ decreaseMonth, increaseMonth, date }: CalendarHeaderProps) => (
    <CommonCalendarHeader decreaseMonth={decreaseMonth} increaseMonth={increaseMonth} date={date} />
  );

  return (
    <DatePicker
      selectsRange
      className={`${calendarInputStyle} ${TextType.body1}`}
      // selected={new Date(startDate)}
      dateFormat='yyyy.MM.dd'
      onChange={handleRange}
      startDate={startDate}
      endDate={endDate}
      minDate={setTomorrow()}
      locale={ko}
      // maxDate={new Date(endDate)}
      renderCustomHeader={renderHeader}
      ref={calendarRef}
    />
  );
};
export default RangeCalendar;
